import request from '@/utils/request'

// 激活码

let CodeApi = {

    /*列表*/
    getList(data, errorback) {
        return request._post('/shop/study.code/index', data, errorback);
    },

    /*添加*/
    add(data, errorback) {
        return request._post('/shop/study.code/add', data, errorback);
    },

    /*删除*/
    del(data, errorback) {
        return request._post('/shop/study.code/del', data, errorback);
    },

    /*编辑*/
    edit(data, errorback) {
        return request._post('/shop/study.code/edit', data, errorback);
    },

    /*批量*/
    batch(data, errorback) {
        return request._post('/shop/study.code/batch', data, errorback);
    },
}

export default CodeApi;



// WEBPACK FOOTER //
// ./src/api/study/code.js